// Misc Getters

export const getBaseUrls = state => {
  return state.baseUrls
}

export const getDisplayGreeting = state => {
  return state.displayGreeting
}

export const getFooterIcons = state => {
  return state.footerIcons
}

export const getMonthListEn = state => {
  return state.monthListEn
}
